export default __webpack_public_path__ + "static/media/trylleby-property-27.1b13e32a.jpg";